import validators from '../../../utils/validators';

class DrugPrescriptionAuthor {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      firstname: (v) => validators.isNotEmptyString(v),
      lastname: (v) => validators.isNotEmptyString(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid DrugPrescriptionAuthor property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }
  }
}

export default DrugPrescriptionAuthor;
